/** Where the Spec Grants app is mounted, which every in-app path is relative to. */
export const specGrantsBasePath = "/spec-grants";

/** Where a request's page lives, relative to the Spec Grants base path. */
export const requestHref = (cycleId: string, requestId: string) =>
  `/requests/${encodeURIComponent(cycleId)}/${encodeURIComponent(requestId)}`;

/** The element id a comment or reply carries on its request's page. */
export const messageAnchorOf = (commentId: string) =>
  `message-${encodeURIComponent(commentId)}`;

/** Where a comment or reply sits on its request's page. */
export const messageHref = (
  cycleId: string,
  requestId: string,
  commentId: string,
) => `${requestHref(cycleId, requestId)}#${messageAnchorOf(commentId)}`;
